// extracted by mini-css-extract-plugin
export default {"Label":"Select_Label__1fAjj","Select":"Select_Select__u+-vD"};